import { render, staticRenderFns } from "./EditPopupContentWrapper.vue?vue&type=template&id=62174276&scoped=true"
import script from "./EditPopupContentWrapper.vue?vue&type=script&lang=js"
export * from "./EditPopupContentWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62174276",
  null
  
)

export default component.exports